<template>
  <div class="private-art-housekeeper-box">
    <mobile-video :videoData="video1"></mobile-video>
    <div class="housekeeper-text-box">
      <div class="lg-title">{{ $t("PrivateArtSteward.ArtSteward") }}</div>
      <div class="text-list-box">
        <div class="content-title">{{ $t("PrivateArtSteward.Content1") }}</div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content2") }}
        </div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content3") }}
        </div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content4") }}
        </div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content5") }}
        </div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content6") }}
        </div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content7") }}
        </div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content8") }}
        </div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content9") }}
        </div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content10") }}
        </div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content11") }}
        </div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content12") }}
        </div>
      </div>
      <div class="text-list-box">
        <div class="content-title">{{ $t("PrivateArtSteward.Content1") }}</div>
        <div class="text text-light-gray">
          {{ $t("PrivateArtSteward.Content14") }}
        </div>
      </div>
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
import mobileVideo from "../../../../components/videoMobile";
export default {
  components: {
    mobileVideo,
  },
  data() {
    return {
      video1: {
        ref: "video1",
        poster: "",
        content: false,
        linkUrl: "",
      },
    };
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
    
    const locale = this.$store.state.locale
    this.video1.linkUrl = locale === 'en' ? 'https://kingsarts-video.oss-cn-hongkong.aliyuncs.com/advisors.mp4' : 'https://kingsarts-video.oss-cn-hongkong.aliyuncs.com/1.614bb652.mp4'
    this.video1.poster = locale === 'en' ? require("../../../../assets/img/advisors.jpg") : require("../../../../assets/img/1.jpg")
  },
};
</script>
<style lang="scss" scoped>
.private-art-housekeeper-box {
  .housekeeper-text-box {
    padding: 65px 35px 0;
    font-size: 28px;
    .text-list-box {
      margin-bottom: 65px;
    }
    .lg-title {
      margin-bottom: 31px;
      font-size: 32px;
    }
    .content-title {
      margin-bottom: 60px;
      font-weight: bold;
    }
    .text {
      margin-bottom: 32px;
      line-height: 44px;
    }
  }
}
</style>